import { useMutation, useApolloClient } from "@apollo/client";
import mutations from "Shared/mutations";
import LocalStorageKeys from "Shared/Constants/LocalStorageKeys";
import { successToast, errorToast } from "Modules/DPToast";
import { useHistory, useLocation } from "Hooks/useRouter";
import { findNearestValidRoute } from "Shared/utils";
import { Provider, SwitchProviderMutation, SwitchProviderMutationVariables } from "generated/graphql";

export const useSwitchProvider = (provider: Provider) => {
  const client = useApolloClient();
  const history = useHistory();
  const location = useLocation();
  const [switchProviderFn] = useMutation<SwitchProviderMutation, SwitchProviderMutationVariables>(
    mutations.SWITCH_PROVIDER,
    {
      variables: { providerId: provider.id },
    }
  );

  const onSwitchProvider = async () => {
    try {
      const { data } = await switchProviderFn();

      if (data && data.switchProvider) {
        localStorage.setItem(
          LocalStorageKeys.userTokenKey,
          data.switchProvider.accessToken
        );

        history.push(findNearestValidRoute(location.pathname));

        client.resetStore().then(() => {
          successToast(data.switchProvider.message);
        });
      }
    } catch {
      errorToast("Failed to switch providers.");
    }
  };

  return { onSwitchProvider };
};
